import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";
import '../Admin/Admin.css';
import Header from "../Home/Header";

export default function NewMemberHome() {
  const navigate = useNavigate();

   useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  return (
    <div className="dashboard">

          <Header />

      <div className="welcome-container">
        <h1 className="welcome-title">MEMBER DETAILS & ATTENDENCE MANAGEMENT</h1>


        <div className="button-container">
          <button className="big-btn" onClick={() => navigate("/member-management")}>
            📝 Registered Member
          </button>


          <button className="big-btn blue" onClick={() => navigate("/attendance-management")}>
                                📝 Member Attendance
                              </button>

         <button className="big-btn blue" onClick={() => navigate("/add-activities")}>
                               📝 Add Physical Activities
                             </button>

           <button className="big-btn" onClick={() => navigate("/member-application")}>
                      📝 View Member Applications
                    </button>



          <button className="big-btn blue" onClick={() => navigate("/membership-management")}>
                      📝 Membership Type
                    </button>


        </div>
      </div>
    </div>
  );
}
